// Confirmation dialog — replaces window.confirm() with a real modal.
// kind='danger' colors the primary button red for destructive ops.

import { useEffect, useState } from 'react';
import { Modal } from './Modal.jsx';
import { __setConfirmEmitter } from '../lib/confirm.js';

export const ConfirmDialog = ({
  title, message, confirmLabel = '确认', cancelLabel = '取消',
  kind = 'normal', onConfirm, onClose
}) => {
  return (
    <Modal
      title={title}
      onClose={onClose}
      width={400}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>{cancelLabel}</button>
          <button className={kind === 'danger' ? 'btn btn-danger' : 'btn btn-primary'}
                  onClick={() => { onConfirm(); onClose(); }}
                  autoFocus>
            {confirmLabel}
          </button>
        </>
      }>
      <div style={{ fontSize: 14, lineHeight: 1.5, color: 'var(--vava-text)', whiteSpace: 'pre-line' }}>
        {message}
      </div>
    </Modal>
  );
};

// Host for the imperative confirmDialog() API (lib/confirm.js). Mount ONCE at
// the app root. Renders the same ConfirmDialog above from a queued request and
// resolves its promise with the user's choice.
export function ConfirmHost() {
  const [req, setReq] = useState(null);
  useEffect(() => { __setConfirmEmitter(setReq); return () => __setConfirmEmitter(null); }, []);
  if (!req) return null;
  // ConfirmDialog fires onConfirm() then onClose(); the first settle wins
  // (promise resolves once), so confirm → true, cancel/Esc/backdrop → false.
  const settle = (val) => { req.resolve(val); setReq(null); };
  return (
    <ConfirmDialog
      title={req.title || '确认操作'} message={req.message}
      confirmLabel={req.confirmLabel} cancelLabel={req.cancelLabel} kind={req.kind}
      onConfirm={() => settle(true)} onClose={() => settle(false)} />
  );
}
